import { img1, img7 } from "../../_components/Imagepath";

export default {
  Data: [
    {
      Id: 1,
      key: 1,
      Ticket: "#4987",
      Subject: "Support for theme",
      Assigned: "Charles Hafner",
      AssignedDate: "17 Dec 2022",
      CreatedOn: "19 Dec 2022, 6:12PM",
      DueDate: "16 Jan 2023",
      Img: img7,
      img: img1,
      Assignee: "John Smith",
      Phone: "+1 843-443-3282",
      LastReply: "18 Jan 2023",
      Priority: "Medium",
      Status: "Closed",
      StatusPending: "Pending",
      StatusOverdue: "Overdue",
      StatusDraft: "Paid",
      StatusRecurring: "Recurring",
      StatusCancelled: "Cancelled",
      Action: "",
    },

  ],
};
